import { render, staticRenderFns } from "./activities-add-or-tongji.vue?vue&type=template&id=271af7ae&scoped=true&"
import script from "./activities-add-or-tongji.vue?vue&type=script&lang=js&"
export * from "./activities-add-or-tongji.vue?vue&type=script&lang=js&"
import style0 from "./activities-add-or-tongji.vue?vue&type=style&index=0&id=271af7ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271af7ae",
  null
  
)

export default component.exports